import i18next from "i18next";
import * as React from "react";
import { fromJSX, Updater, Widget } from "widgets-for-react";
import { AuthState, isLoggedOutState, LoggedOutState } from "./authState";
import { getClassName, options } from "./utils";

function handleSubmit(e:React.FormEvent<HTMLFormElement>, setState:(_: Updater<AuthState>) => void) {
    e.preventDefault();
    setState(s => isLoggedOutState(s) ? ({ ...s, loggedOutState:"two factor - logging", login_ata: s.login_data }) : s);
  }
  
  export function login_two_factor_form(options: options, s0:LoggedOutState, readonly:boolean) : Widget<Updater<AuthState>> {
    return fromJSX((setState: (_: Updater<AuthState>) => void) => (
          <div className={getClassName(options, "blockClassName", "container")} key="login-widget-login-form">
            <div className={getClassName(options, "innerClassName", "py-5")}>
              <header className={getClassName(options, "headerClassName", "mb-4")}>
                <h1 className={getClassName(options, "titleClassName", "mb-4")}>{i18next.t("auth:loginHeader")}</h1>
              </header>

              <form onSubmit={(e) => handleSubmit(e, setState)} className={getClassName(options, "formClassName", "")}>
                <div className={getClassName(options, "formInnerClassName", "")}>
                  <div className={getClassName(options, "formGroupClassName", "form-group")}>
                    <label
                      htmlFor="pin"
                      className={getClassName(options, "formLabelClassName", "")}
                    >
                      {i18next.t("auth:loginMfaPin")}
                    </label>
                    <input
                      type="text"
                      name="pin"
                      id="pin"
                      className={getClassName(options, "formInputClassName", "form-control")}
                      value={s0.login_data.pin}
                      disabled={readonly}
                      onChange={(event) => setState(s => isLoggedOutState(s) ? ({
                        ...s,
                        loggedOutState: "two factor",
                        login_data: {
                          ...s.login_data,
                          pin: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                  </div>

                  <div className={getClassName(options, "formActionsClassName", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickablePrimaryClassName", "btn btn-dark")}
                      disabled={readonly}
                    >
                      {i18next.t("auth:loginMfaSubmit")}
                    </button>

                    <button
                      type="button"
                      className={getClassName(options, "clickableSecondaryClassName", "btn btn-link ml-3")}
                      disabled={readonly}
                      onClick={() => setState(s => ({ ...s, loggedOutState: "two factor - resending pin", login_data: s0.login_data }))}
                    >
                      {i18next.t("auth:loginMfaNewPin")}
                    </button>

                    <button
                      type="button"
                      className={getClassName(options, "clickableTertiaryClassName", "btn btn-link ml-3")}
                      disabled={readonly}
                      onClick={() => setState(s => isLoggedOutState(s) ? ({
                        ...s,
                        status: "logged out",
                        login_data: {
                          email: s.login_data.email,
                          password: s.login_data.password,
                          show_password: false,
                          pin: ''
                        }
                      }) : s)
                      }
                    >
                      {i18next.t("auth:loginMfaCancel")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )
      )
    }